/**
 * Birth Details Model
 * Background data collected during onboarding for pattern analysis
 * Not displayed in prototype interface
 */
export interface BirthLocation {
  city?: string;
  country?: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
}

export interface BirthDetails {
  birthDate: Date | string;
  birthTime?: string; // HH:MM format, 24-hour
  birthLocation?: BirthLocation;
  collectedAt: Date | string;
}

export function createBirthDetails(
  birthDate: Date | string,
  birthTime?: string,
  birthLocation?: BirthLocation
): BirthDetails {
  return {
    birthDate: typeof birthDate === 'string' ? birthDate : birthDate.toISOString(),
    birthTime,
    birthLocation,
    collectedAt: new Date().toISOString(),
  };
}
